module.exports = __webpack_public_path__ + "img/task.a7b9cbe2.png";